/**
 * DevExtreme (esm/__internal/grids/pivot_grid/const.js)
 * Version: 23.1.12
 * Build date: Fri Aug 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var CLASSES = {
    scrollBarMeasureElement: "dx-pivotgrid-scrollbar-measure-element"
};
